import { render, staticRenderFns } from "./AnswerIndex.vue?vue&type=template&id=7087514a&"
import script from "./AnswerIndex.vue?vue&type=script&lang=js&"
export * from "./AnswerIndex.vue?vue&type=script&lang=js&"
import style0 from "./AnswerIndex.vue?vue&type=style&index=0&id=7087514a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports